module.exports = __webpack_public_path__ + "img/refresh.4c1b984f.svg";